import React, { useState, useEffect } from "react";
import ExpectedCampaignsTable from "./components/ExpectedCampaignsTable";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import { v4 as uuid } from "uuid";

export default function ExpectedCampaigns() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [deleteCampaignsIds, setDeleteCampaignsIds] = useState([]);


  const onCampaigns = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}campaign/notConfirmed?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
        ).catch((error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        });
  };

  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}campaign/active`,
        {
          id,
          isActive,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onCampaigns(skip, take, sortField, orderBy);
      });
  };

  const onConfirmStatus = (id) => {
    axios
      .put(
        `${process.env.REACT_APP_API_URL}campaign/approve`,
        {
          id,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onCampaigns(skip, take, sortField, orderBy);
      });
  };

  const onDeleteCampaigns = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}campaign`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteCampaignsIds,
        },
      })
      .then((res) => {
        setDeleteCampaignsIds([]);
        onCampaigns(skip, take, sortField, orderBy);
      });
  };


  const onCampaignCategories = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/category`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
      });
  };

  useEffect(() => {
    onCampaignCategories();
  }, []);

  useEffect(() => {
    onCampaigns(skip, take, sortField, orderBy);
  }, [skip, take, sortField, orderBy]);

  useEffect(() => {
  }, [showView, showEdit]);

  const onCampaignsExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Campaign.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Expected Campaigns</h1>
      </div>
      <Divider className="w-100" />
      <ExpectedCampaignsTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        onConfirmStatus={onConfirmStatus}
        setDeleteCampaignsID={setDeleteCampaignsIds}
        deleteCampaignsIds={deleteCampaignsIds}
        onDeleteCampaigns={onDeleteCampaigns}
        onCampaignsExport={onCampaignsExport}
      />
    </div>
  );
}
